
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import axios from 'axios'

import { FinancialInvoice } from '@/domains/global/models/job-financials.model'
import InvoiceSegment from './InvoiceSegment.vue'

@Component({
  components: { InvoiceSegment }
})
export default class CostSummary extends Vue {
  @Prop({ type: Array, default: () => [] })
  readonly invoices!: FinancialInvoice[]

  @Prop({ type: Boolean, default: false })
  readonly inactive: boolean = false

  activities: any = []

  job: any = []

  invoice: FinancialInvoice | undefined = undefined 

  get showTotalsByStatus () {
    return false
  }

  get totalCost() {
    return this.invoices.reduce((total, invoice) => {
      return total + invoice.total
    }, 0)
  }

  get paidTotal () {
    return this.invoices.filter(i => ['paid', 'refunded'].includes(i.status)).reduce((total, invoice) => {
      return total + invoice.total
    }, 0)
  }

  get pendingTotal () {
    return this.invoices.filter(i => i.status === 'open').reduce((total, invoice) => {
      return total + invoice.total
    }, 0)
  }

  mounted() {
    this.invoice = this.invoices.find(invoice => invoice.type === 'translation')
    this.fetchData()
  }

  goToCheckout() {
    if (this.invoice) {
      const url = new URL(`${axios.defaults.baseURL}/customer-invoices/${this.invoice.id}/checkout`)
      window.location.assign(url.toString())
    }
  }

  anyActivityInDraft() {
    return this.job && this.activities.some((item: any) => item.isDraft)
  }

  async fetchData() {
    if (!this.invoice) {
      return
    }
    try {
      const response = await axios.get(`/jobs/${this.invoice.jobId}/activities`)
      this.activities = response.data as any
      const jobResponse = await axios.get(`/jobs/${this.invoice.jobId}`)
      this.job = jobResponse.data as any
    } catch (error) {
      this.$store.dispatch('error', error)
    }
  }

  async submitJob() {
    try {
      await axios.get(`jobs/${this.$route.params.id}/submit`)
      this.goToCheckout()
    } catch (err: any) {
        const status = err.response.status
        const data = err.response.data
        let message = 'Unable to submit job at this time'

        if (typeof data === 'string') {
          message = `Cannot submit job yet: ${data}`
        } else if (typeof data === 'object' && data.message) {
          message = `Cannot submit job yet: ${data.message}`
        }

        switch (status) {
          case 400:
            this.$store.dispatch('error', message)
            return
          default:
            this.$store.dispatch('error', 'An unexpected error occurred processing your request')
        }
    }
  }
}
